import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { imgUrl } from "../admin/adminApi";
import { CalendarDays, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/blogs`).then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  if (posts.length === 0) return null;
  const [main, ...rest] = posts;

  return (
    <section id="blog" className="py-14 md:py-20 bg-secondary/40 scroll-mt-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div>
            <p className="text-primary font-semibold tracking-wide uppercase text-sm">From Our Blog</p>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mt-2">Beauty Tips & Stories</h2>
          </div>
          <button onClick={() => navigate("/blog")} className="text-primary font-semibold hover:underline underline-offset-4 flex items-center gap-1">
            View all posts <ArrowRight className="w-4 h-4" />
          </button>
        </div>

        <div className="grid lg:grid-cols-2 gap-6">
          <button onClick={() => navigate(`/blog/${main.slug || main.id}`)} className="svc-card text-left group bg-white rounded-2xl overflow-hidden ring-1 ring-black/5 shadow-sm hover:shadow-xl flex flex-col">
            <div className="img-zoom-wrap h-64 md:h-80 overflow-hidden">
              <img src={imgUrl(main.image)} alt={main.title} className="img-zoom w-full h-full object-cover" />
            </div>
            <div className="p-6 flex flex-col flex-1">
              <div className="flex items-center gap-3 text-xs text-gray-500">
                <span className="bg-primary/10 text-primary font-semibold px-2.5 py-1 rounded-full">{main.category}</span>
                <span className="flex items-center gap-1"><CalendarDays className="w-3.5 h-3.5" /> {main.date}</span>
              </div>
              <h3 className="font-display text-2xl font-bold text-gray-900 mt-3 group-hover:text-primary transition-colors">{main.title}</h3>
              <p className="text-gray-600 mt-2 flex-1">{main.excerpt}</p>
              <span className="text-primary font-semibold mt-4 flex items-center gap-1">Read more <ArrowRight className="w-4 h-4" /></span>
            </div>
          </button>

          <div className="grid gap-4">
            {rest.slice(0, 4).map((p) => (
              <button key={p.id} onClick={() => navigate(`/blog/${p.slug || p.id}`)} className="group text-left bg-white rounded-2xl overflow-hidden ring-1 ring-black/5 shadow-sm hover:shadow-lg flex">
                <div className="img-zoom-wrap w-32 md:w-40 shrink-0 overflow-hidden">
                  <img src={imgUrl(p.image)} alt={p.title} className="img-zoom w-full h-full object-cover" />
                </div>
                <div className="p-4 flex flex-col justify-center min-w-0">
                  <div className="flex items-center gap-2 text-[11px] text-gray-500">
                    <span className="text-primary font-semibold">{p.category}</span>
                    <span>· {p.date}</span>
                  </div>
                  <h4 className="font-semibold text-gray-900 mt-1 leading-snug line-clamp-2 group-hover:text-primary transition-colors">{p.title}</h4>
                  <p className="text-sm text-gray-500 mt-1 line-clamp-2">{p.excerpt}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog;
